// Version : 0.0.1
// Author : VIGNESH

import { takeLatest, put, all, call } from 'redux-saga/effects';

import { goldLoanCollectionListGet } from './gold-loan-collection-report.service';

import {
	getGoldLoanCollectionDetailsSuccess,
	getGoldLoanCollectionDetailsFailure,
	getGoldLoanCollectionDetailsResponseChanged,
} from './gold-loan-collection-report.action';

import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import goldLoanCollectionActionTypes from './gold-loan-collection-report.types';

/** *********************  START GOLD COLLECTION REPORT LIST ******************** */
export function* getGoldLoanCollectionList({ payload }: any) {
	try {
		const {
			companyID,
			searchType,
			branchID,
			centerID,
			groupID,
			funderID,
			databaseName,
			fromDate,
			toDate,
			userLevel,
			Limit,
			tillDate,
		} = payload;
		const key = 'GetGoldLoanCollectionReportKey';
		const jsonData = {
			CompanyID: companyID,
			SearchType: searchType,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			FunderID: funderID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			// IsThriftActive: payload.IsThriftActive,
			UserLevel: userLevel,
			Limit: Limit,
			TillDate: tillDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(goldLoanCollectionListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGoldLoanCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getGoldLoanCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGoldLoanCollectionDetailsFailure(error));
	}
}

export function* resetGetGoldLoanCollectionListResponse() {
	yield put(getGoldLoanCollectionDetailsResponseChanged());
}

export function* onGetGoldLoanCollectionListDetails() {
	yield takeLatest(
		goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_START,
		getGoldLoanCollectionList,
	);
}

export function* onGetGoldLoanCollectionListResponseReset() {
	yield takeLatest(
		goldLoanCollectionActionTypes.GET_GOLD_LOAN_COLLECTION_LIST_RESPONSE_RESET,
		resetGetGoldLoanCollectionListResponse,
	);
}
/** *********************  END GOLD COLLECTION REPORT LIST ******************** */

export function* reportGoldLoanCollectionSaga() {
	yield all([
		call(onGetGoldLoanCollectionListDetails),
		call(onGetGoldLoanCollectionListResponseReset),
	]);
}
